/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var First = require('.')
var Last = require('../core/types').proxy('Last')

var curry = require('../core/curry')
var isFunction = require('../core/isFunction')
var isSameType = require('../core/isSameType')

var applyTransform = function (last) { return First(last.valueOf()); }

// lastToFirst : Last a -> First a
// lastToFirst : (a -> Last b) -> a -> First b
function lastToFirst(last) {
  if(isFunction(last)) {
    return function(x) {
      var m = last(x)

      if(!isSameType(Last, m)) {
        throw new TypeError('lastToFirst: Last returning function required')
      }

      return applyTransform(m)
    }
  }

  if(isSameType(Last, last)) {
    return applyTransform(last)
  }

  throw new TypeError('lastToFirst: Last or Last returning function required')
}

module.exports = curry(lastToFirst)
